// src/global-components.js or src/component.js

import netWork from './../components/network/network-slot.vue'
import netWorkInfo from './../components/network/network-info.vue'
// import fileUpload from './../components/file-upload.vue'
// import sakuraTime from './../components/sakura-time.vue'
// import sakuraTimeColumn from './../components/sakura-time-column.vue'
// import sakuraDays from './../components/sakura-days.vue'
// import sakuraToggleSelect from './../components/sakura-toggle-select.vue'
// import materialInput from './../components/material-input.vue'
// import netWorkShure from './../components/network-shure/network-slot.vue'
// import stackHeader from './../pages/common/stack-header.vue'
// import stackDialogHeader from './../pages/common/stack-dialog-header.vue'
// import lagBox from './../pages/common/lag-box.vue'
// import netWorkConnected from './../components/network-connected/network-slot.vue'
// import netWorkMoreVlan from './../components/network-more-vlan/network-slot.vue'
// import sakuraTabsRouter from './../components/sakura-tabs-router.vue'

export default [
  { name: 'network', component: netWork },
  { name: 'networkSlot', component: netWork },
  { name: 'netWorkInfo', component: netWorkInfo },
//   { name: 'fileUpload', component: fileUpload },
//   { name: 'sakuraTime', component: sakuraTime },
//   { name: 'sakuraTimeColumn', component: sakuraTimeColumn },
//   { name: 'sakuraDays', component: sakuraDays },
//   { name: 'sakuraToggleSelect', component: sakuraToggleSelect },
//   { name: 'materialInput', component: materialInput },
//   { name: 'netWorkShure', component: netWorkShure },
//   { name: 'stackHeader', component: stackHeader },
//   { name: 'stackDialogHeader', component: stackDialogHeader },
//   { name: 'lagBox', component: lagBox },
//   { name: 'netWorkConnected', component: netWorkConnected },
//   { name: 'netWorkMoreVlan', component: netWorkMoreVlan },
//   { name: 'sakuraTabsRouter', component: sakuraTabsRouter },
]
